<template>
  <section class="collections">
    <div class="collections-container">
      <div class="collections-title">
        <h3>在 KY精選 你想到的，都找得到！</h3>
        <p>我們涵蓋了各專櫃保養品，快選擇符合的類型開始購物吧！</p>
      </div>
      <div class="collections-items">
        <div v-for="collection in collections" :key="collection.id" class="collections-item">
          <router-link to="/products">
            <img :src="collection.image" :alt="collection.name">
            <div class="collections-content">
              <h5>{{ collection.name }}</h5>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Collections',
  computed: {
    ...mapState(['collections'])
  }
}
</script> 

<style scoped>
.collections {
    margin: 2rem auto;
}

.collections .collections-container {
    height: 100%;
    max-width: 1200px;
    margin: 0 auto;
}

.collections .collections-container .collections-title {
    text-align: center;
    margin-bottom: 3rem;
}

.collections .collections-container .collections-title h3 {
    font-size: 3rem;
    font-weight: 700;
    color: #333;
}

.collections .collections-container .collections-title p {
    font-size: 1.2rem;
    font-weight: 300;
    color: #333;
    text-decoration: none;
}

/* 橫向三張卡片圓角 */
.collections .collections-container .collections-items {
    display: flex;
    gap: 2rem;
    justify-content: center;
    align-items: center;
}

.collections .collections-container .collections-item {
    height: 100%;
    width: 30%;
    border-radius: 10px;
    overflow: hidden;
}

.collections .collections-container .collections-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.collections .collections-container .collections-item .collections-content h5 {
    font-size: 1.2rem;
    font-weight: 700;
    color: gray;
    text-align: center;
    text-decoration: none;
}
</style>